module.exports = __webpack_public_path__ + "static/media/BobabarProcess2.b434fec2.jpg";